import {
    DELETE_PROPERTYGROUP,
    DELETE_PROPERTYGROUP_FAILURE,
    DELETE_PROPERTYGROUP_SUCCESS,
} from 'store/actions/types';

export const deletePropertyGroup = (payload) => {
    return {
        type: DELETE_PROPERTYGROUP,
        payload: payload,
    };
};

export const deletePropertyGroupFailure = (error) => {
    return {
        type: DELETE_PROPERTYGROUP_FAILURE,
        error: error,
    };
};

export const deletePropertyGroupSuccess = (payload) => {
    return {
        type: DELETE_PROPERTYGROUP_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/propertygroups/deletePropertygroups.js